import React, { useState } from "react";
import { connect } from "react-redux";

function Video(props) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div 
      className="video"
      style={{
        marginBottom: "10px"
      }}
    >
      {/* Video Player */}
      <div style={{ 
        position: "relative",
        paddingBottom: "56.25%", // 16:9 aspect ratio
        height: 0,
        overflow: "hidden",
        borderRadius: "8px",
        backgroundColor: "#000"
      }}>
        <iframe
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          }}
          src={props.url}
          title={props.name}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Optional: Additional Info Section (if you want to show more details) */}
      {props.description && props.showDescription && (
        <div style={{
          marginTop: "12px",
          padding: "10px",
          backgroundColor: "#f8f9fa",
          borderRadius: "5px",
          fontSize: "14px",
          lineHeight: "1.6"
        }}>
          <p style={{ margin: 0, color: "#555" }}>
            {isExpanded ? props.description : `${props.description.substring(0, 100)}...`}
          </p>
          {props.description.length > 100 && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              style={{
                marginTop: "8px",
                padding: "4px 12px",
                fontSize: "12px",
                border: "none",
                backgroundColor: "#007bff",
                color: "#fff",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              {isExpanded ? "Show Less" : "Read More"}
            </button>
          )}
        </div>
      )}

      {/* Optional: Category Badge (if passed separately) */}
      {props.category && props.showCategory && (
        <div style={{
          marginTop: "10px",
          display: "inline-block",
          padding: "4px 10px",
          fontSize: "11px",
          fontWeight: "600",
          color: "#007bff",
          backgroundColor: "#e7f3ff",
          borderRadius: "12px",
          textTransform: "uppercase"
        }}>
          {props.category}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    profile_pic_url: state.profile_pic_url,
    profile_pic_alt: state.profile_pic_alt,
  };
};

export default connect(mapStateToProps, {})(Video);